import { Stack } from "@mui/system";
import { useCallback, useEffect, useState } from "react";
import Banner from "../components/Banner";
import FilteringChips from "../components/FilteringChips";
import HorizontalVideoGroup from "../components/HorizontalVideoGroup";
import useAxios from "../hooks/useAxios";
import { useNavigate, useSearchParams } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import PoweredBy from "../components/layout/PoweredBy";

export default function Home() {
  const [categories, setCategories] = useState();
  const [loading, setLoading] = useState();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const zainPhone = searchParams.get("msisdn");
  const [active, setActive] = useState(0);
  const { saveToken, savePhoneNumber } = useAuth();
  const axios = useAxios();

  const login = useCallback(async () => {
    try {
      const body = { phoneNumber: zainPhone };
      const response = await axios.post("auth", body);
      saveToken(response?.data?.accessToken);
      savePhoneNumber(zainPhone);
    } catch (error) {}
    navigate("/");
  }, []);

  useEffect(() => {
    zainPhone && login(); //handle zain redirect to login
    const fechCaregories = async () => {
      try {
        const response = await axios.get("category");
        setCategories(response.data);
      } catch (error) {}
    };
    fechCaregories();
  }, [axios]);

  return (
    <>
      <Banner />
      <Stack mx="auto" maxWidth="70rem" width="100%" pb={3}>
        <FilteringChips
          active={active}
          setActive={setActive}
          loading={loading}
        />

        <HorizontalVideoGroup
          categoryId={0}
          activeFilter={active}
          setLoading={setLoading}
        />

        {categories &&
          categories?.map((category, i) => {
            return (
              category?.itemsCount > 0 && (
                <HorizontalVideoGroup
                  key={category?.id}
                  title={category?.name?.ar}
                  categoryId={category?.id}
                  last={i === categories?.length - 1}
                />
              )
            );
          })}
      </Stack>
      <PoweredBy mx="auto" display="block" />
    </>
  );
}
